













import {Component, Prop, Vue} from "vue-property-decorator";
import JsonViewer from 'vue-json-viewer'
import axios from "axios";
import {Getter} from "vuex-class";

@Component({
    components: {
        JsonViewer,
        VisualComponent: () => import("@/valchrom/views/mathservice/dataset/overview/VisualComponent.vue"),

    }
})
export default class ImageComponent extends Vue {
    @Prop() model: any;
    @Getter token !: any;
    @Getter currentExperimentalDatasetID !: any;
    @Getter math_service_url !: any;
    imageData: any = "";

    mounted(){
        let inputUrl = this.math_service_url + "dataset/" +
            this.currentExperimentalDatasetID + "/file/" + this.model.id;
        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        axios.get(
            inputUrl,
            {
                headers: {
                    jwt: this.token
                },
                withCredentials: true,
                responseType: 'arraybuffer'
            }
        )
            .then(
                response => {
                    console.log("Got image file response", response);
                    this.imageData = Buffer.from(response.data, 'binary').toString('base64');
                })
            .catch(
                error => {
                    console.log("error on GET csv file", error);
                }
            );
    }

}
